export const Label = (props: JSX.IntrinsicElements['label']) => {
  return <label {...props}>{props.children}</label>;
};
